export * from './beneficiaria.model';
export * from './beneficiaria.component';
export * from './beneficiaria.service';

export * from './view-beneficiaria/view-beneficiaria.component';
export * from './view-beneficiaria/detail-beneficiaria/detail-beneficiaria.component';

export * from './form-beneficiaria/form-beneficiaria.component';
